import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@nstep-common/core';

@Component({
	selector: 'app-under-maintenance',
	templateUrl: './under-maintenance.component.html',
	standalone: false
})
export class UnderMaintenanceComponent extends BaseComponent implements OnInit {
	ngOnInit(): void {
		super.ngOnInit();
	}
}